// extracted by mini-css-extract-plugin
module.exports = {"newCardContainer":"AddNewCard_newCardContainer__BUYlF"};